import { render, staticRenderFns } from "./DVfieldBoolean.vue?vue&type=template&id=673d7e04&scoped=true"
import script from "./DVfieldBoolean.vue?vue&type=script&lang=js"
export * from "./DVfieldBoolean.vue?vue&type=script&lang=js"
import style0 from "./DVfieldBoolean.vue?vue&type=style&index=0&id=673d7e04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../usr/local/lib/node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "673d7e04",
  null
  
)

export default component.exports